export const sxStyle = {
  root: {
    backgroundColor: '#F6F6F6',
    justifyContent: 'center',
    minHeight: '175px',
    py: {
      xs: '10px',
      sm: '50px',
    },
  },
};
